<div class="item-grid-container px-3 pt-0">
  
  <div class="search-holder">
    <ul class="list-inline grid-top-actions w-90 mb-3">
      <li class="list-inline-item">
        <p class="mb-2 mx-2">{{'pages.Creditlinereport.From' | translate }}</p>
      </li>
      
      <li class="list-inline-item">
        <div class="calendar-btn">
          <input
            matInput
            [matDatepicker]="dpFrom"
            disabled
            [min]="minFromDate"
            placeholder="MM/DD/YYYY"
            [max]="maxDate"
            [formControl]="fromCtrl"
            (dateChange)="changeFromDate($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="dpFrom"
          ></mat-datepicker-toggle>
          <mat-datepicker #dpFrom disabled="false"></mat-datepicker>
        </div>
      </li>
      <li class="list-inline-item">
        <p class="mb-2 mx-2">{{'pages.Creditlinereport.To' | translate }}</p>
      </li>
      <li class="list-inline-item">
        <div class="calendar-btn">
          <input
            matInput
            [matDatepicker]="dpTo"
            disabled
            [min]="minToDate"
            placeholder="MM/DD/YYYY"
            [max]="maxDate"
            [formControl]="toCtrl"
            (dateChange)="changeToDate($event);"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="dpTo"
          ></mat-datepicker-toggle>
          <mat-datepicker #dpTo disabled="false"></mat-datepicker>
        </div>
      </li>
      <li class="list-inline-item">
        <div class="search-holder">
          <input
            type="text"
            placeholder="{{ 'pages.newRetailer.search' | translate }}"
            matInput
            class="
              rounded-pill
              px-3
              py-2
              mb-0
              border-0
              bg-light
              w-100
              me-0
              input-search
              ms-3
            "
            (keyup)="quickSearch()"
            [(ngModel)]="searchValue"
          />
          <i
            color="primary"
            class="search-icon-holder"
            matSuffix
            mat-icon-button
            aria-label="Search"
          >
            <mat-icon>search</mat-icon>
          </i>
        </div>
      </li>
      <li *ngIf="!isButtonDisabled" class="list-inline-item float-end mx-2">
        <button
          mat-stroked-button
          [disabled]="showUpdateUser"
          class=""
          (click)="updateFestival()"
        >
          {{ "pages.newRetailer.edit" | translate }}
          <i class="mi mi-drive-file-rename-outline"></i>
        </button>
      </li>
      <li class="list-inline-item float-end mx-2">
        <!-- adding import button -->
        <button
        [disabled]="isButtonDisabled"
          class="btn-import"
          mat-stroked-button
          [routerLink]="['../import-promo-code']"
          routerLinkActive="router-link-active"
        >
          <span translate class="translate">Import</span>
        </button>
        <button
        [disabled]="isButtonDisabled"
            mat-stroked-button
            [routerLink]="['../create-festival']"
            routerLinkActive="router-link-active"
          >
            <span translate class="translate">{{'pages.placeholders.AddFestival' | translate }}</span>
            <i class="mi mi-add-box"></i>
          </button>
      </li>
      
    </ul>
  </div>
  <ag-grid-angular
    style="width: 100%; height: 65vh"
    class="ag-theme-material"
    [rowHeight]="40"
    [enableFilter]="true"
    [enableSorting]="true"
    [enableColResize]="true"
    [rowSelection]="rowSelection"
    [rowData]="ocassionRewards"
    [columnDefs]="occasionRewardsColumnDef"
    (gridReady)="onGridReady($event)"
    (selectionChanged)="onSelectionChanged($event)"
  >
  </ag-grid-angular>
</div>
